import React, { Component, Fragment } from 'react';
import { transform } from 'ol/proj.js';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Controls from '@ro-components/Controls';
import ControlItem from '@ro-components/ControlItem';
import AnimationSwitch from '@ro-components/AnimationSwitch';
import { DatePicker } from 'material-ui-pickers';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import { withRouter } from 'react-router-dom';
import { MenuOpenButton } from '@ro-atoms/Menu';
import { zoomAnimation, downloadScreen, resetMapRotation } from '@ro-utils/common/map/events';
import 'intro.js/introjs.css';
import { RoDropdownItem } from '@ro-components/RoDropdown';
import { translate } from 'react-i18next';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { dispatch } from '@ro-store';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Menu from '@material-ui/core/Menu';
import { MenuButtonWrapper } from '@ro-atoms/Menu/MenuOpenButton/MenuOpenButton.styles';

import { setCoord, animationByCoord, coordTransformed } from '@ro-utils/common/map/events';

import MenuIcon from '@material-ui/icons/Menu';
import { RADAR_FORMAT } from '@ro-utils/constant';

class ControlsContainer extends Component {
  constructor(props) {
    super(props);
    this.format = RADAR_FORMAT;
    this.state = {
      anchorEl: null
    };
  }

  handleClickFavorite = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleCloseFavorite = () => {
    this.setState({ anchorEl: null });
  };

  handleDateChange(date) {
    const isToday = moment().isSame(date, 'day');
    dispatch.ro.loading(true);
    dispatch.ro.setDate({
      date: isToday ? false : date
    });
  }

  onExit = () => {
    this.setState(() => ({ stepsEnabled: false }));
  };
  render() {
    const { userSettings, t, date, mapType, queryString, tutorialStarted, currentRotation } = this.props;

    const { anchorEl } = this.state;

    const {
      spOptions,
      estofexOptions,
      radarOptions,
      lightningsOptions,
      map,
      layersVisibilities,
      synopOptions,
      orderOptions
    } = userSettings.shortcuts;

    const editableSections = {
      map,
      radar: radarOptions,
      skypredict: spOptions,
      estofex: estofexOptions,
      detector: lightningsOptions,
      visibilities: layersVisibilities,
      synop: synopOptions,
      order: orderOptions
    };

    const leftControls = {
      visibility: {
        rotation: currentRotation,
        ...editableSections,
        // anchor: true,
        printScreen: true,
        favorites: true,
        geolocation: true
      },
      badge: {
        favorites: {
          color: ['purple', 500, 500],
          text: userSettings.favoriteLocations.length + (userSettings.geolocation ? 1 : 0)
        },
        radar: {
          text: mapType.toUpperCase(),
          invert: true
        },
        // anchor: {
        //   invert: true,
        //   asActive: Boolean(userSettings.anchor),
        // },
        geolocation: {
          invert: true,
          asActive: Boolean(userSettings.geolocation)
        }
      },
      txtColor: {
        favorites: 'white'
      },
      dropdown: {
        favorites: {
          ariaOwns: Boolean(anchorEl) ? 'render-favorite-menu' : undefined,
          ariaHaspopup: true
        }
      },
      color: {
        rotation: ['red', 500, 500]
      },
      link: {
        ...editableSections,
        // anchor: false,
        printScreen: false
      },
      action: {
        // anchor: () =>
        //   dispatch.ro.toggleAnchor(!userSettings.anchor).then(() => {
        //     return userSettings.anchor && dispatch.ro.setCurrentLocation({}).then(() => this.handleDateChange(date));
        //   }),
        printScreen: downloadScreen,
        favorites: this.handleClickFavorite,
        geolocation: () => dispatch.ro.setGeolocation(!userSettings.geolocation),
        rotation: () => {
          resetMapRotation();
          return dispatch.ro.setCurrentRotation(0);
        }
      }
    };

    const rightControls = {
      visibility: {
        zoomOut: true,
        zoomIn: true,
        search: true,
        // fanpage: true,
        tutorial: false,
        appVersion: false,
        weather: true
      },
      color: {
        zoomOut: ['grey', 50, 50],
        zoomIn: ['grey', 50, 50],
        appVersion: ['red', 500, 500],
        tutorial: userSettings.tutorialLevel === false ? ['green', 700, 700] : ['red', 500, 500],
        weather: ['red', 500, 500]
      },
      txtColor: {
        zoomOut: 'black',
        zoomIn: 'black',
        tutorial: 'white'
      },
      badge: {
        tutorial: {
          color: ['red', 500, 500],
          text: !this.props.tutorialStarted && userSettings.tutorialLevel ? '!' : '',
          direction: 'left',
          invert: true
        }
      },
      link: {
        zoomOut: false,
        zoomIn: false,
        search: true,
        fanpage: true,
        appVersion: true,
        weather: true
      },
      externalLink: {
        appVersion: true,
        weather: true
      },
      action: {
        zoomOut: () => zoomAnimation(global.RO_MAP, -1),
        zoomIn: () => zoomAnimation(global.RO_MAP, +1),
        tutorial: () => dispatch.ro.setHelpModal(true)
      }
    };

    const controlRenderer = controls => {
      return Object.keys(controls['visibility']).map((control, i) => {
        const option = radartype => {
          const controlParam = controls[radartype];
          return controlParam && controlParam[control];
        };
        const dropdown = option('dropdown');
        const dropdownProps = dropdown || {};

        return option('visibility') ? (
          <div key={`${i}_leftControlAction`} className={`ro_tool_${control}`} onClick={option('action')}>
            <ControlItem
              key={`${i}_control`}
              link={option('link') && t(`routes.${control}`) + (!option('externalLink') ? queryString : '')}
              tooltip={t(`titles.${control}`)}
              icon={t(`icons.controls.${control}`)}
              selected={option('active')}
              color={option('color')}
              txtColor={option('txtColor')}
              iconSize={16}
              badge={option('badge')}
              {...dropdownProps}
            />
          </div>
        ) : null;
      });
    };

    const DateControl = props => {
      return (
        <ControlItem
          tooltip={t(`titles.history`)}
          onClick={props.onClick}
          icon={t(`icons.controls.history`)}
          iconSize={16}
          color={['pink', 800, 800]}
          badge={{
            color: ['purple', 500, 500],
            text: date && moment(date).format('DD.MM.YY'),
            direction: 'left',
            invert: true
          }}
        />
      );
    };
    return (
      <Fragment>
        <Controls tutorialLevel={userSettings.tutorialLevel} tutorialStarted={tutorialStarted}>
          {controlRenderer(leftControls)}
          <Menu
            id="render-favorite-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            transition
            placement={'right-start'}
            PaperProps={{
              style: {
                width: 330
              }
            }}
          >
            <ClickAwayListener onClickAway={this.handleCloseFavorite}>
              <div>
                {userSettings.geolocation && (
                  <RoDropdownItem
                    item={{
                      name: 'Aktualna lokalizacja'
                    }}
                    leftIcon={'flag-checkered'}
                    divider={userSettings.favoriteLocations.length}
                    onMenuItemClick={() => {
                      const coordinates = global.RO_GEOLOCATION.getPosition();
                      dispatch.ro.setCurrentLocation(
                        setCoord(transform(coordinates, 'EPSG:3857', 'EPSG:4326'), 'Aktualna lokalizacja', {
                          date
                          // mapType,
                          // anchor: userSettings.anchor,
                        })
                      );
                      animationByCoord(coordinates);
                      this.handleCloseFavorite();
                    }}
                  />
                )}
                {Boolean(userSettings.favoriteLocations.length)
                  ? userSettings.favoriteLocations.map((item, i) => {
                      return (
                        <RoDropdownItem
                          key={uuid()}
                          item={item}
                          onRemove={item => dispatch.ro.removeFavoriteLocation(i)}
                          onMenuItemClick={item => {
                            const zoom = item.location.zoom;
                            dispatch.ro
                              .setCurrentLocation({
                                ...setCoord(item.location.original, item.name, {
                                  zoom
                                }),
                                isFavorite: true
                              })
                              .then(() => {
                                animationByCoord(coordTransformed(item.location.original), zoom);
                              });
                            this.handleCloseFavorite();
                          }}
                        />
                      );
                    })
                  : !userSettings.geolocation && (
                      <span style={{ padding: '0 10px', outline: 'none' }}>Lista jest pusta</span>
                    )}
              </div>
            </ClickAwayListener>
          </Menu>
        </Controls>
        <Controls direction="right" tutorialLevel={userSettings.tutorialLevel} tutorialStarted={tutorialStarted}>
          {controlRenderer(rightControls)}
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <div className="ro_tool_history">
              <DatePicker
                okLabel={t(`datepicker.ok`)}
                cancelLabel={t(`datepicker.cancel`)}
                todayLabel={t(`datepicker.today`)}
                value={date || new Date()}
                showTodayButton
                onChange={e => this.handleDateChange(e)}
                TextFieldComponent={DateControl}
                maxDate={moment()}
                minDate={'2012-03-03'}
              />
            </div>
          </MuiPickersUtilsProvider>
          <div className="ro_tool_animation">
            <AnimationSwitch />
          </div>
          <MenuButtonWrapper className="ro_tool_menu">
            <MenuOpenButton>
            <Link to={t(`routes.menu`) + queryString}>
                <ControlItem tooltip={t(`titles.menu`)} switcher size={1.3} iconComponent={<MenuIcon />} />
              </Link>
            </MenuOpenButton>
          </MenuButtonWrapper>
        </Controls>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ ro }) => ro;

export default withRouter(connect(mapStateToProps)(translate('common')(ControlsContainer)));
